<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        offset-sm="6"
        sm="6"
      >
        <v-text-field
          v-model="search"
          class="mb-4"
          append-icon="mdi-magnify"
          :label="$t('Search')"
          single-line
          hide-details
        />
      </v-col>
    </v-row>
    <v-card>
      <questions-table
        :faq-id="faq.id"
        :questions="questions"
        :search="search"
        :team-users-count="teamUsersCount"
      />
    </v-card>
  </div>
</template>

<script>
import Layout from '@/components/shared/TheLayout';
import TabsLayout from '@/components/faq/TabsLayout';
import QuestionsTable from '@/components/faq/QuestionsTable';

export default {
  components: {
    QuestionsTable
  },

 layout: (h, page) => h(Layout, {
    props: {
      noWrappingContainer: true,
      pageTitle: page.data.props.faq.default_translation.name
    }
  }, [h(TabsLayout, {
    props: {
      activeTab: 'questions',
      faq: page.data.props.faq
    }
  }, [page])]),

  props: {
    faq: {
      type: Object,
      required: true
    },
    questions: {
      type: Array,
      required: true
    },
    teamUsersCount: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      search: ''
    }
  }
}
</script>